import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";

const MisReservas = () => {
    const { getAccessToken, getUserData } = useUser();
    const user = getUserData();
    const token = getAccessToken();

    let tableButtons = []

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "reservas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaMisReservas",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/reservas?personaId=${user.id}`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error listanto los parametros"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "fecha" },
            { data: "hora_inicio" },
            { data: "hora_fin" },
            { data: "asunto" },
            { data: "recurso" },
            { data: "tema" },
            { data: "observacion" },
            { data: "status" }
        ],
        columnDefs: [
            {
                targets: [8],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    RESERVAS / Mis Reservas
                </div>
            </div>
            <Datatable options={dtOptions}>
                <table className="w-100 table table-hover" id="tablaMisReservas">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Fecha</th>
                            <th className="text-center text-white">Inicio</th>
                            <th className="text-center text-white">Fin</th>
                            <th className="text-center text-white">Asunto</th>
                            <th className="text-center text-white">Recurso</th>
                            <th className="text-center text-white">Tema</th>
                            <th className="text-center text-white">Observacion</th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
        </ContentWrapper>
    );
};

export default MisReservas;